<div class="new-svideo-block" [ngClass]="{'sp': fromSvideoPage}"
    *ngIf="!!video && display === videoDisplay.NewsBlock">
    <div class="box" (mouseenter)="openPlayer()" (mouseleave)="onMouseLeave()">
        <a title="{{ video.title }}" [routerLink]="['/watch']" [queryParams]="{v:video.key }">
            <div class="image-content d-block position-relative">
                <img class="poster d-block"
                    src="{{ video.image  | safeResource }}?w=640&h=360&format=jpg&mode=crop" alt="{{ video.title}}"
                    loading="lazy" />
                <div class="shadow-bar"></div>
                <div class="hot-count">
                    <i class="iconfont iconrenqi mr-1"></i>
                    <span class="num">
                        {{ video.userData?.viewCount || video.views || video.view || 0 | chineseCounter}}
                    </span>
                </div>
                <div class="video-length">
                    <span class="num">
                        {{ video.videoLength || (video.lastseconds.split('.')[0].split(':').slice(1).join(':')) }}
                    </span>
                </div>
            </div>
        </a>
        <div class="abs" [hidden]="isTouchDevice">
            <app-simple-videoplayer *ngIf="showPlayer"
                [video]="video" [mediaList]="pendingPlayList['medias']" (onVideoReady)="onPlayerReady($event)"
                (onPlay)="onPlayStart($event)" (onEnd)="onPlayEnd($event)" class="hover-preview-player"
                [ngClass]="{'active': playSuccess}">
            </app-simple-videoplayer>
        </div>


    </div>

    <div class="title-box">
        <a [routerLink]="[ '/watch'] " [queryParams]="{v: video.key}" title="{{ video.title }}">
            {{ video.title }}
        </a>
    </div>
    <div class="upload-box" [ngClass]="{'sp': fromSvideoPage}">
        <div class="uploader">
            <a [routerLink]="[ '/space/', video.userKey || video.uploaderKey]"
                title="{{ video.nickName || video.uploaderName }}" class="position-relative">
                <img class="avatar" src="{{ video.avatar | safeResource }}?w=21&h=21&mode=crop" [lazyLoad]
                    alt="{{ video.nickName || video.uploaderName}}" loading="lazy" />
                <img *ngIf="video.isOfficalUP" class="official-up-logo-on-avatar"
                    [src]="'./assets/images/officalUp.png?v=1'|absUrl" loading="lazy" alt="大V标" />
                <span class="ml-2 nickName">{{ video.nickName || video.uploaderName }}</span>
            </a>
        </div>
        <div class="upload-date">
            {{ video.add_Date || (video.published | date: 'yyyy-MM-dd') || (video.addTime | date: 'yyyy-MM-dd') }}
        </div>
    </div>
</div>